import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import * as fas from "@fortawesome/free-solid-svg-icons";
import * as far from "@fortawesome/free-regular-svg-icons";
import { UserStore } from './stores/users.store';
import { PreferencesService } from './services/preferences/preferences.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Gameface';

  readonly user$ = inject(UserStore) ;
  private readonly $preferences = inject(PreferencesService) ;
  

  constructor(library: FaIconLibrary) {

    this.user$.load();

    library.addIcons(
      fas.faCaretUp,
      fas.faCaretDown,
      fas.faCaretLeft,
      fas.faCaretRight,


      fas.faEllipsis,
      fas.faEllipsisVertical,
      fas.faPlay,
      fas.faRotateLeft,
      fas.faRotateRight,
      fas.faChevronLeft,
      fas.faChevronRight,

      fas.faCheck,
      fas.faPlus,
      fas.faTimes,

      far.faCircle,
      fas.faCircleQuestion,
      fas.faCircleExclamation,
      fas.faCircleMinus,
      fas.faCircleNotch,
      fas.faCirclePlay,
      fas.faCircleHalfStroke,
      fas.faTimesCircle,
      fas.faCheckCircle,
      fas.faCirclePlus,
      fas.faCircleDown,
      fas.faCircleChevronDown,

      fas.faSquarePlus,
      fas.faSquareMinus,

      fas.faFaceSmile,
      fas.faGrinStars,
      fas.faFaceMeh,
      fas.faFaceAngry,
      fas.faFaceGrinBeamSweat,

      fas.faChalkboardUser,


      fas.faThumbsUp,
      fas.faThumbsDown,

      fas.faBold,
      fas.faItalic,
      fas.faUnderline,
      fas.faStrikethrough,
      fas.faCode,

      fas.faDoorClosed,

      fas.faBars,
      fas.faSearch,
      fas.faEye,
      fas.faEyeSlash,
      fas.faCamera,
      fas.faNoteSticky,
      fas.faFloppyDisk,
      fas.faMobileScreenButton,
      fas.faDice,
      fas.faTrash,
      fas.faStar,
      far.faStar,
      fas.faCopy,
      
      fas.faCloudArrowDown,
      fas.faFilePen,
  
      fas.faPaperPlane,
      fas.faHeart,
      fas.faShield,
      fas.faImage,
      fas.faExclamation,
      fas.faExclamationTriangle,
    ) ;

  }
}
